const routerArr = [
    {
        path: '/promotionCenter',
        name: 'promotionCenter',
        meta: { title:'推广中心',login:false },
        component: () => import(/* webpackChunkName: 'promotion' */ './page/promotionCenter.vue'),
    },
    {
        path: '/promotionCenterMine',
        name: 'verification',
        meta: { title:'推广中心',login:false },
        component: () => import(/* webpackChunkName: 'promotion' */ './page/promotionCenterMine.vue'),
    },
    {
        path: '/cumulativeRevenueList',
        name: 'cumulativeRevenueList',
        meta: { title:'累计收益',login:false },
        component: () => import(/* webpackChunkName: 'promotion' */ './page/cumulativeRevenueList.vue'),
    },
    {
        path: '/cumulativeRevenueDetail',
        name: 'cumulativeRevenueDetail',
        meta: { title:'累计收益',login:false },
        component: () => import(/* webpackChunkName: 'promotion' */ './page/cumulativeRevenueListDetail.vue'),
    },
    {
        path: '/seeTuiguangQrcode',
        name: 'seeTuiguangQrcode',
        meta: { title:'累计收益',login:false },
        component: () => import(/* webpackChunkName: 'promotion' */ './page/seeTuiguangQrcode.vue'),
    },
  ]
  export default routerArr